import SlideDown from 'react-slidedown';

import styled from 'styled-components';

import { Info } from '../styles';

export const DetailsSlideDown = styled(SlideDown)`
  transition-duration: 0.2s;
`;

export const Content = styled.div`
  /* use padding, so it doesn't affect SlideDown calcs */
  padding: 16px 24px;

  & ${Info} {
    margin: 4px 0;
  }
`;
